/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Export_Open_ProfileInputs */

const cs_social_export_open_profile = /** @type {(inputs: Social_Export_Open_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevřít nastavení profilu`)
};

const en_social_export_open_profile = /** @type {(inputs: Social_Export_Open_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open profile settings`)
};

/**
* | output |
* | --- |
* | "Open profile settings" |
*
* @param {Social_Export_Open_ProfileInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_export_open_profile = /** @type {((inputs?: Social_Export_Open_ProfileInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Export_Open_ProfileInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_export_open_profile(inputs)
	return cs_social_export_open_profile(inputs)
});